/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCurrentUserHospitalChatSignatureRequest
 */
export interface UpdateCurrentUserHospitalChatSignatureRequest {
    /**
     * User's hospital chat signature (max 170 characters)
     * @type {string}
     * @memberof UpdateCurrentUserHospitalChatSignatureRequest
     */
    hospital_chat_signature: string;
}

/**
 * Check if a given object implements the UpdateCurrentUserHospitalChatSignatureRequest interface.
 */
export function instanceOfUpdateCurrentUserHospitalChatSignatureRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hospital_chat_signature" in value;

    return isInstance;
}

export function UpdateCurrentUserHospitalChatSignatureRequestFromJSON(json: any): UpdateCurrentUserHospitalChatSignatureRequest {
    return UpdateCurrentUserHospitalChatSignatureRequestFromJSONTyped(json, false);
}

export function UpdateCurrentUserHospitalChatSignatureRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCurrentUserHospitalChatSignatureRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hospital_chat_signature': json['hospital_chat_signature'],
    };
}

export function UpdateCurrentUserHospitalChatSignatureRequestToJSON(value?: UpdateCurrentUserHospitalChatSignatureRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hospital_chat_signature': value.hospital_chat_signature,
    };
}

